import { useState } from "react";
import { useNavigate } from "react-router-dom";

const ROLE_REDIRECTS = {
  superadmin: "/superadmin/dashboard",
  admin: "/admin/dashboard",
  employee: "/employee/dashboard",
};

const ROLE_LABELS = {
  superadmin: { label: "Super Admin", icon: "🛡️", color: "#f59e0b" },
  admin: { label: "Admin", icon: "👑", color: "#6c63ff" },
  employee: { label: "Employee", icon: "🧑‍💼", color: "#10b981" },
};

export default function StaffLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("https://lightslategrey-mole-360881.hostingersite.com/api/auth/staff-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      // console.log("Full response:", data);

      if (!res.ok) {
        throw new Error(data.message || "Login failed");
      }

      // Check if token exists
      if (!data.token) {
        console.error("No token in response!");
        throw new Error("No token received from server");
      }

      const role = data.role;
      const token = data.token;

      // console.log("Token received:", token.substring(0, 50) + "...");
      // console.log("Role received:", role);

      if (!role || !ROLE_REDIRECTS[role]) {
        throw new Error("Unauthorized access. Invalid role.");
      }

      // Store token
      localStorage.setItem("kkb_token", token);
      localStorage.setItem(
        "kkb_user",
        JSON.stringify({
          id: data.id,
          name: data.name,
          email: data.email,
          role: data.role,
        }),
      );

      // Verify storage
      const storedToken = localStorage.getItem("kkb_token");
      // console.log("Token stored successfully:", storedToken ? "Yes" : "No");

      if (!storedToken) {
        throw new Error("Failed to store token");
      }

      navigate(ROLE_REDIRECTS[role]);
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0a0c12",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          background: "#12151f",
          border: "1px solid #1e2235",
          borderRadius: 20,
          padding: "44px 40px",
          width: 380,
          boxShadow: "0 24px 60px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ marginBottom: 28 }}>
          <h2
            style={{ color: "#fff", fontWeight: 800, fontSize: 22, margin: 0 }}
          >
            KKB Staff Portal
          </h2>
          <p style={{ color: "#5a6278", fontSize: 13, marginTop: 6 }}>
            Sign in as SuperAdmin, Admin, or Employee
          </p>
        </div>

        <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
          {Object.entries(ROLE_LABELS).map(([role, { label, icon, color }]) => (
            <div
              key={role}
              style={{
                flex: 1,
                background: "#0a0c12",
                border: `1px solid ${color}33`,
                borderRadius: 8,
                padding: "7px 6px",
                textAlign: "center",
                fontSize: 11,
                color,
                fontWeight: 600,
              }}
            >
              <div style={{ fontSize: 16, marginBottom: 2 }}>{icon}</div>
              {label}
            </div>
          ))}
        </div>

        <form
          onSubmit={handleLogin}
          style={{ display: "flex", flexDirection: "column", gap: 12 }}
        >
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={inputStyle}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={inputStyle}
          />

          {error && (
            <div
              style={{
                background: "#1f0a0a",
                border: "1px solid #ef444440",
                borderRadius: 8,
                padding: "9px 12px",
                color: "#ef4444",
                fontSize: 13,
              }}
            >
              ⚠️ {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              background: loading
                ? "#2e3352"
                : "linear-gradient(135deg, #6c63ff, #4f46e5)",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "12px",
              fontWeight: 700,
              fontSize: 14,
              cursor: loading ? "not-allowed" : "pointer",
              marginTop: 4,
              transition: "opacity 0.2s",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Signing in..." : "Sign In →"}
          </button>
        </form>
      </div>
    </div>
  );
}

const inputStyle = {
  background: "#0a0c12",
  border: "1px solid #1e2235",
  borderRadius: 8,
  padding: "11px 14px",
  color: "#e2e8f0",
  fontSize: 13,
  outline: "none",
  width: "100%",
  boxSizing: "border-box",
};
